"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SVBSwitch", {
  enumerable: true,
  get: function get() {
    return _SVBSwitch.default;
  }
});
var _SVBSwitch = _interopRequireDefault(require("./src/SVBSwitch"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }